<template lang="pug">
	.user-list
		.page-center-content
			.caption-area User list
			.publishers-table
				//- update-if не даёт таблице запрашивать пользователей, пока открыта другая страница
				//- (экран всегда считает себя показанным и реагирует на "Publishers Changed" на старте)
				DataTable(entity="users" :fields="fields" :filters="filters" key-field="id" :sort="['register_date', 'desc']" :update-on="['Layout Page Showed:user-list']" :update-if="() => Layout.page === 'user-list'" focus-on="Layout Page Showed:user-list" :server-id="serverId || undefined" :height-offset="Layout.headerHeight + 45")
					//- Нода кластера: пользователи каждой ноды хранятся в её БД, поэтому список
					//- запрашивается у выбранной ноды (по умолчанию - у ноды выбранного паблишера)
					template(slot="header-controls-extra")
						.node-filter
							label
								span Node:
								select.custom-select.custom-select-sm.form-control.form-control-sm(v-model="serverId" @change="updateServer")
									option(v-for="server in getServers()" :value="server.id") {{server.title || ('Node ' + server.id)}}

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Publisher } 		from './../../services/Publisher'

	import DataTable			from './../../components/Templates/DataTable'

	export default {
		name: "UserList",
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Page Showed:user-list"],
			events: {
				"Publishers Changed": function() {
					this.updateFiltersValues();
					this.update();
				}
			}
		},
		components: {
			DataTable
		},
		data() {

			this.fields = [
				{
					fieldName: 'id',
					title: 'ID',
					type: 'number',
					display: true,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '70px'
				},
				{
					fieldName: 'photo',
					title: 'Photo',
					type: 'image',
					display: true,
					click: this.openUserProfile,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '50px'
				},
				{
					fieldName: 'name',
					title: 'Name',
					type: 'string',
					display: true,
					click: this.openUserProfile,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '200px'
				},
				{
					fieldName: 'publisher_id',
					title: 'Publisher',
					type: 'number',
					display: true,
					displayTransform: publisher_id => Publisher.getPublisher(publisher_id)?.title,
					click: this.publisherClick,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '200px'
				},
				/*{
					fieldName: 'email',
					title: 'Email',
					type: 'string',
					display: true,
					sortingAllowed: true,
					filteringAllowed: true,
					width: '250px'
				},*/
				{
					fieldName: 'tags',
					title: 'Tags',
					type: 'array',
					display: true,
					displayTransform: tag => ({'admin': 'Admin', 'publisher-admin': 'Company admin', 'invitation': 'Invitation'})[tag] || null,
					displayStyles: tag => ({'Admin': {color: '#20a8d8', fontWeight: 'bold'}, 'Company admin': {color: '#63c2de'}, 'Invitation': {color: '#73818f'}})[tag] || null,
					split: ',',
					sortingAllowed: false,
					filteringAllowed: false,
					width: '50px'
				},
				{
					fieldName: 'register_date',
					title: 'Register',
					type: 'date',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					width: '150px'
				},
				{
					fieldName: 'last_activity_time',
					title: 'Activity',
					type: 'date',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					width: '150px'
				},
				{
					fieldName: 'options',
					title: 'Options',
					type: 'object',
					display: false,
					filteringAllowed: false
				},
				{
					fieldName: 'active',
					title: 'Active',
					type: 'boolean',
					display: true,
					sortingAllowed: true,
					filteringAllowed: false,
					editAllowed: true,
					onChange: this.activateUser,
					width: '90px'
				}
			];

			this.filters = [{
				title: 'Publisher',
				field: 'publisher_id',
				type: 'equal',
				value: '',
				options: [],
				display: true
			}, {
				title: 'Tag',
				field: 'tags',
				type: 'contain:comma',
				value: '',
				options: [{
					title: '',
					value: ''
				}, {
					title: 'Admin',
					value: 'admin'
				}, {
					title: 'Company admin',
					value: 'publisher-admin'
				}, {
					title: 'Invitation',
					value: 'invitation'
				}],
				display: true
			}];

			return {
				showed: true,
				// Нода, у которой запрашивается список пользователей (пусто - нода выбранного паблишера)
				serverId: null
			}

		},
		methods: {
			collectData() {

				if (this.serverId) return;

				this.serverId = Publisher.getSelectedServerId();

				this.updateFiltersValues();

			},
			// Ноды кластера для выбора: список нод есть в метаданных (таблица metadata_servers)
			getServers() {

				return _.values(Metadata.Servers || {});

			},
			// Пользователи и паблишеры у каждой ноды свои: меняем ноду и перечитываем фильтры
			updateServer() {

				this.updateFiltersValues();

			},
			updateFiltersValues() {

				this.filters[0].options = _.map(Publisher.getPublishersByServer(this.serverId), publisher => {return {title: publisher.title, value: publisher.id}});
				this.filters[0].options.splice(0, 0, {title: '', value: ''});

			},
			publisherClick(user) {

				Publisher.switchPublisher(Publisher.getPublisher(user['publisher_id'], this.serverId));

			},
			openUserProfile(user) {

				Layout.setPage('user-profile', {userId: user.id, backPage: ['user-list', {}]});

			},
			activateUser(user) {

				Server.sendToSocket({
					SetUserStatus: {
						userId: user.id,
						active: user.active
					}
				})

			}
		}
	}
</script>

<style lang="sass" scoped>

	.user-list
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1000px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)
				padding: 0.7rem 1rem

			.publishers-table
				display: flex
				flex-direction: row
				flex-wrap: wrap
				padding: 1rem 0

				.node-filter
					display: flex
					align-items: center
					padding: 0 15px

					label
						display: flex
						align-items: center
						margin: 0

						span
							margin-right: 5px
							white-space: nowrap

						select
							width: auto

</style>

